
// src/reducers/divisions-settings-reducer.js

import { 
  FETCH_DIVISION_GROUP,
  FETCH_DIVISION_GROUP_REQUESTED,
  FETCH_DIVISION_GROUP_COMPLETED,
  FETCH_DIVISION_GROUP_FAILED
} from '../actions/divisions-group-manager'

const initialState = {
  isFetchedGroup: false,
  groupSort: 'desc',
  divisionGroups: []
}

export default function divisionSettingsReducer(state = initialState, action = {}) {
  switch(action.type) {

    case FETCH_DIVISION_GROUP_COMPLETED:
      return Object.assign({}, state, {
        divisionGroups: action.results
      })

    default:

    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/divisions-group-manager-reducer.js